import React from "react";
import { useInView } from "react-intersection-observer";
import LogoMark from "./LogoMark";
import banner from "../assets/images/banner.png";

const About = () => {
  const { ref: sectionRef, inView: sectionInView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });
  const { ref: pillarsRef, inView: pillarsInView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  return (
    <section id="about">
      <div className="about-visual">
        <div className="about-blocks">
          <div className="ab ab-1">
            <div className="ab-watermark">
              <LogoMark
                width={180}
                height={190}
                red="#c1c1c1"
                yellow="#f1f1f1"
                blue="#e1e1e1"
                orange="#616161"
              />
            </div>
          </div>
          <div
            className="ab ab-2"
            style={{
              background: `url(${banner}) center center`,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          ></div>
          <div className="ab ab-3"></div>
          <div className="ab-badge">
            <div className="ab-badge-num">12+</div>
            <div className="ab-badge-label">Years of Craft</div>
          </div>
        </div>
      </div>

      <div className="about-content">
        <div
          className={`section-tag ${sectionInView ? "visible" : ""}`}
          ref={sectionRef}
        >
          <span className="section-tag-icon"></span> Who We Are
        </div>
        <h2 className={`section-title ${sectionInView ? "visible" : ""}`}>
          Built on <em>Precision</em>
          <br />& Craft
        </h2>
        <p className="about-lead">
          Trusted by startups and established enterprises across South Africa,
          Gauweng delivers strategic digital and technology solutions that drive
          measurable growth, operational efficiency, and long-term business
          success. We bring together deep technical expertise, industry
          knowledge, and a genuine commitment to service excellence - helping
          organisations navigate digital transformation with clarity and
          confidence.
        </p>

        <p className="about-body">
          At Gauweng, we recognise that every business is unique. Our team of
          experienced specialists works closely with founders, executives, and
          business leaders to develop tailored solutions that align with your
          strategic goals, address real operational challenges, and create
          lasting value.
        </p>

        <p className="about-body">
          We are committed to professionalism, transparency, and delivering
          results our clients can rely on. From digital infrastructure to
          complex business improvement projects, every engagement is approached
          with the same discipline - precision execution, full accountability,
          and an unwavering focus on your growth.
        </p>

        <div
          className={`about-pillars ${pillarsInView ? "visible" : ""}`}
          ref={pillarsRef}
        >
          <div className="pillar pillar-accent">
            <div className="pillar-name">Precision</div>
            <div className="pillar-desc">
              Every detail shapes the difference between good and exceptional.
            </div>
          </div>
          <div className="pillar pillar-blue">
            <div className="pillar-name">Transparency</div>
            <div className="pillar-desc">
              Fixed budgets, weekly updates, zero hidden fees - always.
            </div>
          </div>
          <div className="pillar pillar-blue">
            <div className="pillar-name">Accountability</div>
            <div className="pillar-desc">
              We take full ownership of every outcome - successes and lessons
              alike.
            </div>
          </div>
          <div className="pillar pillar-dark">
            <div className="pillar-name">Craft</div>
            <div className="pillar-desc">
              Quality over quantity - exceptional care and craft in every
              project we deliver.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
